import TextBox from "../../componets/TextBox";
import designData from "../../data/logoAndBrandingDesign.json";

export default function Section3() {
  return (
    <div className="Section3">
      <h2 className="w-[90%] my-[24px] md:mb-0 md:w-[61%] mx-auto text-center text-[24px] leading-[32px] md:text-[34px] font-bold md:leading-[41px] text-[#151515] mt-[40px]">
        Why <span className="text-[#DA2128]"> Logo & Branding</span> Design
        Matters
      </h2>

      <TextBox data={designData} oddStyle="bg-[#E42E35] text-white" evenStyle="bg-[#f5f5f5] text-[#373737]" />
      <section className="w-[90%] md:w-[80%] mx-auto flex flex-col md:flex-row items-center justify-between gap-8 py-12 px-4 bg-white">
        {/* Text Section */}
        <div className="md:w-1/2">
          <h2 className="font-bold mb-4 text-[#DA2128] leading-[normal] text-[24px] md:text-[34px]">
            Why Choose Mean3 for Logo & Branding?
          </h2>
          <p className="text-[#373737] font-open text-[16px] mb-6">
            We’re not just designers—we’re brand thinkers. We have a strong background in logo and
            brand design. We’ve collaborated with businesses in many industries. We know
            how important it is to build a brand that stands out and earns trust in the market. Our team fuses
            creative skills with industry knowledge to craft logo designs that stand out and last. We focus on
            real impact, not just trends.
          </p>
          <h2 className="font-bold mb-4 text-[#DA2128] leading-[normal] text-[24px] md:text-[34px]">
            Let’s Design a Brand Logo That Builds Trust
          </h2>
          <p className="text-[#373737] font-open text-[16px]">
            At Mean3, we’re ready to help you create a brand logo that drives real results. We offer logo
            and branding services to help you build your reputation. We aim to connect you with your
            audience and support your business goals. If you're a business in Pakistan looking for a reliable
            logo design partner, we're here to guide you from idea to execution. Let’s work together to
            design a brand identity that truly works for you.
          </p>
        </div>

        {/* Image Section */}
        <div className="md:w-1/2">
          <img
            src="../../../../assets/brand.png"
            alt="Logo Design"
            className="w-full h-auto rounded-xl shadow-md"
          />
        </div>
      </section>
    </div>
  );
}
